import { useMemo } from 'react'
import usePersonaPresenceRange from './usePersonaPresenceRange'

// AI-CONTEXT: See docs/pitfalls.md#dev-copied-recipe-instead-of-shared-hook
//
// Alle aanwezigheidsrapporten van één kalenderjaar, in één ophaalactie. Dat is
// bewust: twaalf losse maandvragen leveren twaalf keer een half getekend
// scherm op, terwijl de gebruiker juist om het jaar in één oogopslag vroeg.
//
// Let op de omvang. Bij twintig deelnemers met een volledig rooster staan er
// ruwweg vijfduizend documenten in een jaar. Dat is te doen voor een eenmalige
// leesactie, maar het is geen query om per toetsaanslag te herhalen — vandaar
// dat alleen het jaartal hem opnieuw laat draaien.

/**
 * @param {number|null|undefined} year - 4-cijferig jaartal, of null zolang dat
 *   nog niet bekend is
 * @param {{ enabled?: boolean }} [options] - Met `enabled: false` wordt er niet
 *   gehaald.
 * @returns {{ reports: Array<object>, loaded: boolean }} `loaded` blijft
 *   `false` zolang het antwoord onderweg is, zodat het scherm 'nog niet
 *   bekend' niet als 'niets gevonden' toont.
 */
const usePersonaPresenceYear = (year, { enabled = true } = {}) => {
    const bounds = useMemo(() => {
        if (!year) return { start: null, end: null }
        return {
            start: new Date(year, 0, 1).getTime(),
            end: new Date(year, 11, 31, 23, 59, 59).getTime(),
        }
    }, [year])

    return usePersonaPresenceRange(bounds.start, bounds.end, { enabled })
}

export default usePersonaPresenceYear
